import request from '@/utils/request'
/**查询特材原料-特材成品 */
export function productqueryPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/queryPage',
    method: 'post',
    data
  })
}
/**验收标准-保存或修改 */
export function saveOrUpdAcceptanceCriteria(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/saveOrUpdAcceptanceCriteria',
    method: 'post',
    data
  })
}
/**验收标准-列表 */
export function getAcceptanceCriteria(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/getAcceptanceCriteria',
    method: 'post',
    data
  })
}
/**获取参数设置 */
export function getParameterSetting(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/getParameterSetting',
    method: 'post',
    data
  })
}
/**获取检验项目/检验要求列表 */
export function getCheckProjectList(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/getCheckProjectList',
    method: 'post',
    data
  })
}
/**保存或删除检验项目/检验要求 */
export function saveOrUpdCheckProject(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/saveOrUpdCheckProject',
    method: 'post',
    data
  })
}
/**保存或删除检验项目/检验要求 */
export function saveOrUpdParameterSetting(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/saveOrUpdParameterSetting',
    method: 'post',
    data
  })
}
/**获取检验类别 */
export function getCheckTypeList(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/getCheckTypeList',
    method: 'post',
    data
  })
}
/**物料检测绑定-保存或修改 */
export function saveOrUpdRawBindInfo(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/saveOrUpdRawBindInfo',
    method: 'post',
    data
  })
}
/**物料检测绑定返回--列表 */
export function getBindInfoList(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/getBindInfoList',
    method: 'post',
    data
  })
}